module.exports = __webpack_public_path__ + "static/media/obecon.fa1b84ed.svg";